import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { PageLayout } from '../../../../../components/generics/PageLayout';
import { TableAjustesGlobalesIa } from './components/TableAjustesGlobalesIa';
import { BannerInfoAjustesGlobalesIa } from './components/BannerInfoAjustesGlobalesIa';
import { hasPemissions } from '../../../../../commons/utils';
import { Link } from 'react-router-dom';

export const AjustesGlobalesIa = () => {
    const [canCreate, setCanCreate] = useState(false);

    useEffect(() => {
        canCheckCanCreate();
    }, []);

    const canCheckCanCreate = async () => {
        const havePermissions = await hasPemissions('modulo.manager', 'modulo.manager.plataforma.ia', 'create', 'modulo.manager.plataforma.ia.configuracion', 'modulo.manager.plataforma.ia.configuracion.ajustes');
        setCanCreate(havePermissions);
    }

    return (
        <PageLayout
            title="Ajustes Globales IA"
            mainModule="Manager"
            icon="Tune"
            infoAlert="Configura los parámetros globales de Inteligencia Artificial."
            actionButtons={
                <>
                    {canCreate && (
                        <Button 
                            variant="contained" 
                            color="primary" 
                            startIcon={<AddIcon />} 
                            component={Link}
                            to={'/manager/plataforma-ia/configuracion/ajustes/crear'}
                            sx={{
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                fontWeight: 600,
                                textTransform: 'none',
                                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                            }}
                        >
                            Nueva Configuración
                        </Button>
                    )}
                </>
            }
        >
            <TableAjustesGlobalesIa />
            
            <BannerInfoAjustesGlobalesIa />
        </PageLayout>
    );
};
